import { z } from 'zod'

export const indexerVectorSearchResponseSchema = z.object({
  results: z.array(
    z.object({
      document_number: z.string(),
    })
  ),
})

export const fullIndexerPatentDetailsSchema = z.object({
  document_number: z.string(),
  application_number: z.string(),
  publication_number: z.string(),
  family_id: z.string().nullable(),
  jurisdiction: z.string(),
  kind: z.string(),

  title: z.string(),
  abstract: z.string(),
  claims: z
    .array(
      z.object({
        claim_id: z.string(),
        is_dependent: z.boolean(),
        plain_text: z.string(),
        sequence: z.number(),
      })
    )
    .default([]),
  descriptions: z
    .array(
      z.object({
        plain_text: z.string(),
        sequence: z.number(),
      })
    )
    .default([]),

  publication_date: z.string().nullable(),
  priority_date: z.string().nullable(),
  projected_expiration_date: z.string().nullable(),
  last_updated: z.string(),
  application_date: z.string().nullable(),

  is_licensed: z.boolean().nullable(),
  is_litigated: z.boolean().nullable(),
  legal_status: z.string().nullable(),

  publication_type: z.string().nullable(),

  current_assignees: z.array(z.string()),
  applicants: z.array(z.string()),
  inventors: z.array(z.string()),

  backward_citations: z.array(z.string()),
  forward_citations: z.array(z.string()),

  cpc_symbols: z.array(z.string()),
})

export type FullIndexerPatentDetails = z.infer<
  typeof fullIndexerPatentDetailsSchema
>

export type IndexerPatentField = keyof FullIndexerPatentDetails

export const indexerCitationSchema = fullIndexerPatentDetailsSchema
  .pick({
    document_number: true,
    title: true,
    publication_date: true,
    priority_date: true,
    current_assignees: true,
  })
  .transform((data) => ({
    documentNumber: data.document_number,
    title: data.title,
    publicationDate: data.publication_date,
    priorityDate: data.priority_date,
    currentAssignees: data.current_assignees,
  }))

export type IndexerCitation = z.infer<typeof indexerCitationSchema>
